import React, { useState, useEffect } from 'react'
import api from './../../components/api'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import { useTabelaGestao } from '../../context/GestaoPendenciasContext'

import { useEnergiaEletricaCompradaContext } from '../../context/energiaCompradaContext'
import { useEnergiaEletricaGeradaContext } from '../../context/energiaGeradaContext'



import { useEnunciadoContext } from '../../context/enunciadoContext'
import { useVerificaDesafioContext } from '../../context/verificaDesafioContext'
import { useSecaoEnunciadoContext } from '../../context/secaoEnunciadoContext'

import StatusValidacaoSecao from '../StatusValidacaoSecao'

const EnergiaEletrica = (props) => {

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()
    const { energiaEletricaComprada_id, setEnergiaEletricaComprada_id } = useEnergiaEletricaCompradaContext()

    var ano = props.ano
    var adesao_institucional_id = props.adesao_institucional_id
    var energia_id = props.energia_id

    
    
    const [tipoEnergia, setTipoEnergia] = useState('')

    const [tipoConsumidor, setTipoConsumidor] = useState('')
    const [descricaoFatura, setDescricaoFatura] = useState('')
    const [concessionaria, setConcessionaria] = useState('')
    const [percDescontoTSUD, setPercDescontoTSUD] = useState('')
    const [percRenovavel, setPercRenovavel] = useState('')


    const [pontaJan, setPontaJan] = useState('')
    const [foraJan, setForaJan] = useState('')    
    const [demJan, setDemJan] = useState('')
    const [demForaJan, setDemForaJan] = useState('')
    const [custoJan, setCustoJan] = useState('')

    const [pontaFev, setPontaFev] = useState('')
    const [foraFev, setForaFev] = useState('')
    const [demFev, setDemFev] = useState('')
    const [demForaFev, setDemForaFev] = useState('')
    const [custoFev, setCustoFev] = useState('')

    const [pontaMar, setPontaMar] = useState('')
    const [foraMar, setForaMar] = useState('')
    const [demMar, setDemMar] = useState('')
    const [demForaMar, setDemForaMar] = useState('')    
    const [custoMar, setCustoMar] = useState('')

    const [pontaAbr, setPontaAbr] = useState('')
    const [foraAbr, setForaAbr] = useState('')
    const [demAbr, setDemAbr] = useState('')
    const [demForaAbr, setDemForaAbr] = useState('')
    const [custoAbr, setCustoAbr] = useState('')

    const [pontaMai, setPontaMai] = useState('')
    const [foraMai, setForaMai] = useState('')
    const [demMai, setDemMai] = useState('')
    const [demForaMai, setDemForaMai] = useState('')
    const [custoMai, setCustoMai] = useState('')

    const [pontaJun, setPontaJun] = useState('')
    const [foraJun, setForaJun] = useState('')
    const [demJun, setDemJun] = useState('')
    const [demForaJun, setDemForaJun] = useState('')
    const [custoJun, setCustoJun] = useState('')

    const [pontaJul, setPontaJul] = useState('')
    const [foraJul, setForaJul] = useState('')
    const [demJul, setDemJul] = useState('')
    const [demForaJul, setDemForaJul] = useState('')
    const [custoJul, setCustoJul] = useState('')

    const [pontaAgo, setPontaAgo] = useState('')
    const [foraAgo, setForaAgo] = useState('')
    const [demAgo, setDemAgo] = useState('')
    const [demForaAgo, setDemForaAgo] = useState('')
    const [custoAgo, setCustoAgo] = useState('')

    const [pontaSet, setPontaSet] = useState('')
    const [foraSet, setForaSet] = useState('')
    const [demSet, setDemSet] = useState('')
    const [demForaSet, setDemForaSet] = useState('')
    const [custoSet, setCustoSet] = useState('')

    const [pontaOut, setPontaOut] = useState('')
    const [foraOut, setForaOut] = useState('')
    const [demOut, setDemOut] = useState('')
    const [demForaOut, setDemForaOut] = useState('')
    const [custoOut, setCustoOut] = useState('')

    const [pontaNov, setPontaNov] = useState('')
    const [foraNov, setForaNov] = useState('')
    const [demNov, setDemNov] = useState('')
    const [demForaNov, setDemForaNov] = useState('')
    const [custoNov, setCustoNov] = useState('')

    const [pontaDez, setPontaDez] = useState('')
    const [foraDez, setForaDez] = useState('')
    const [demDez, setDemDez] = useState('')
    const [demForaDez, setDemForaDez] = useState('')
    const [custoDez, setCustoDez] = useState('')


    const [tipoSistema, setTipoSistema] = useState('')
    const [tipoConexao, setTipoConexao] = useState('')
    const [fonte, setFonte] = useState('')
    const [potenciaNominal, setPotenciaNominal] = useState('')
    const [fatorPotencia, setFatorPotencia] = useState('')

    //const [energiaEletricaComprada_id, setEnergiaEletricaComprada_id] = useState()
    const [resultadoComprada, setResultadoComprada] = useState()

    const { energiaEletricaGerada_id, setEnergiaEletricaGerada_id} = useEnergiaEletricaGeradaContext()
    const [resultadoGerada, setResultadoGerada] = useState()

    const [resultadoConcessionarias, setResultadoConcessionarias] = useState()




    const [key, setKey] = useState('home')

    const [subgrupoLista, setSubGrupoLista] = useState()
    const [ambienteContratacao, setAmbienteContratacao] = useState()
    const [lista, setLista] = useState([])
    const [subgrupo, setSubGrupo] = useState()


    const [modalidadeTarifariaLista, setModalidadeTariafariaLista] = useState()
    const [modalidadeTarifaria, setModalidadeTarifaria] = useState()
    const [listaMod, setListaMod] = useState([])



    var { enunciado, setEnunciado } = useEnunciadoContext()
    var { setSecaoEnunciado } = useSecaoEnunciadoContext()
    var { verificaDesafio } = useVerificaDesafioContext()




    const [questao, setQuestao] = useState()
    const [totalPendencias, setTotalPendencias] = useState(0)


    useEffect(() => {

        verificaValidacoes()

    }, [energia_id, verificaDesafio])


    const verificaValidacoes = () => {

        //console.log('verificado')

        setQuestao()
        

        if (energia_id) {

            var dataPost = {

                formulario_id: energia_id,
                desafio: 'Energia',

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                var data = result.data
                //console.log(data)
                var totalErros = 0

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {


                        switch (data[k].enunciado) {

                            case 'Energia Elétrica':

                                totalErros = totalErros + 1
                                setQuestao('red')
    
                            break

                            
                        }

                    }

                    

                }

                setTotalPendencias(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }




    function salva() {



        if (descricaoFatura == '') {

            //window.toastr.error('<b>Descrição da Fatura</b> não pode ficar em branco!')
            //return false

        }

        if (concessionaria == '') {

            window.toastr.error('<b>Concessionária</b> não pode ficar em branco!')
            return false

        }



        if (tipoEnergia == 'comprada') {



            if (ambienteContratacao == '') {

                window.toastr.error('<b>Ambiente de Contratação</b> não pode ficar em branco!')
                return false
    
            }
    
    
            if (subgrupo == '') {
    
                window.toastr.error('<b>Subgrupo</b> não pode ficar em branco!')
                return false
    
            }
    
    
            if (modalidadeTarifaria == '') {
    
                window.toastr.error('<b>Modalidade Tarifária</b> não pode ficar em branco!')
                return false
    
            }
    
    

            if (ambienteContratacao == 'Livre') {

                if (tipoConsumidor == '') {

                    window.toastr.error('<b>Tipo de Consumidor</b> não pode ficar em branco!')
                    return false

                }

                /*

                if (percDescontoTSUD == '') {

                    window.toastr.error('<b>% de desconto na TUSD/TUST</b> não pode ficar em branco!')
                    return false

                }

                if (percRenovavel == '') {

                    window.toastr.error('<b>% de energia renovável</b> não pode ficar em branco!')
                    return false

                }

                */
            
            } else {

                setTipoConsumidor('')
                setPercDescontoTSUD('')
                setPercRenovavel('')

            }


            var dataPost = {

                energia_id: energia_id,
                adesao_institucional_id: adesao_institucional_id,
                ano: ano,
                
                tipoEnergia: tipoEnergia,
                
                tipoConsumidor: tipoConsumidor,
                subgrupo: subgrupo,
                ambienteContratacao: ambienteContratacao,
                modalidadeTarifaria: modalidadeTarifaria,
                descricaoFatura: descricaoFatura.toUpperCase(),
                concessionaria: concessionaria,
                percDescontoTSUD: percDescontoTSUD,
                percRenovavel: percRenovavel,

                pontaJan: pontaJan == null ? '' : pontaJan.toString(),
                foraJan: foraJan == null ? '' : foraJan.toString(),    
                demJan: demJan == null ? '' : demJan.toString(),
                demForaJan: demForaJan == null ? '' : demForaJan.toString(),
                custoJan: custoJan == null ? '' : custoJan.toString(),

                pontaFev: pontaFev == null ? '' : pontaFev.toString(),
                foraFev: foraFev == null ? '' : foraFev.toString(),
                demFev: demFev == null ? '' : demFev.toString(),
                demForaFev: demForaFev == null ? '' : demForaFev.toString(),
                custoFev: custoFev == null ? '' : custoFev.toString(),

                pontaMar: pontaMar == null ? '' : pontaMar.toString(),
                foraMar: foraMar == null ? '' : foraMar.toString(),
                demMar: demMar == null ? '' : demMar.toString(),
                demForaMar: demForaMar == null ? '' : demForaMar.toString(),    
                custoMar: custoMar == null ? '' : custoMar.toString(),

                pontaAbr: pontaAbr == null ? '' : pontaAbr.toString(),
                foraAbr: foraAbr == null ? '' : foraAbr.toString(),
                demAbr: demAbr == null ? '' : demAbr.toString(),
                demForaAbr: demForaAbr == null ? '' : demForaAbr.toString(),
                custoAbr: custoAbr == null ? '' : custoAbr.toString(),

                pontaMai: pontaMai == null ? '' : pontaMai.toString(),
                foraMai: foraMai == null ? '' : foraMai.toString(),
                demMai: demMai == null ? '' : demMai.toString(),
                demForaMai: demForaMai == null ? '' : demForaMai.toString(),
                custoMai: custoMai == null ? '' : custoMai.toString(),

                pontaJun: pontaJun == null ? '' : pontaJun.toString(),
                foraJun: foraJun == null ? '' : foraJun.toString(),
                demJun: demJun == null ? '' : demJun.toString(),
                demForaJun: demForaJun == null ? '' : demForaJun.toString(),
                custoJun: custoJun == null ? '' : custoJun.toString(),

                pontaJul: pontaJul == null ? '' : pontaJul.toString(),
                foraJul: foraJul == null ? '' : foraJul.toString(),
                demJul: demJul == null ? '' : demJul.toString(),
                demForaJul: demForaJul == null ? '' : demForaJul.toString(),
                custoJul: custoJul == null ? '' : custoJul.toString(),

                pontaAgo: pontaAgo == null ? '' : pontaAgo.toString(),
                foraAgo: foraAgo == null ? '' : foraAgo.toString(),
                demAgo: demAgo == null ? '' : demAgo.toString(),
                demForaAgo: demForaAgo == null ? '' : demForaAgo.toString(),
                custoAgo: custoAgo == null ? '' : custoAgo.toString(),

                pontaSet: pontaSet == null ? '' : pontaSet.toString(),
                foraSet: foraSet == null ? '' : foraSet.toString(),
                demSet: demSet == null ? '' : demSet.toString(),
                demForaSet: demForaSet == null ? '' : demForaSet.toString(),
                custoSet: custoSet == null ? '' : custoSet.toString(),

                pontaOut: pontaOut == null ? '' : pontaOut.toString(),
                foraOut: foraOut == null ? '' : foraOut.toString(),
                demOut: demOut == null ? '' : demOut.toString(),
                demForaOut: demForaOut == null ? '' : demForaOut.toString(),
                custoOut: custoOut == null ? '' : custoOut.toString(),

                pontaNov: pontaNov == null ? '' : pontaNov.toString(),
                foraNov: foraNov == null ? '' : foraNov.toString(),
                demNov: demNov == null ? '' : demNov.toString(),
                demForaNov: demForaNov == null ? '' : demForaNov.toString(),
                custoNov: custoNov == null ? '' : custoNov.toString(),

                pontaDez: pontaDez == null ? '' : pontaDez.toString(),
                foraDez: foraDez == null ? '' : foraDez.toString(),
                demDez: demDez == null ? '' : demDez.toString(),
                demForaDez: demForaDez == null ? '' : demForaDez.toString(),
                custoDez: custoDez == null ? '' : custoDez.toString(),

                percDescontoTSUD: percDescontoTSUD == null ? '' : percDescontoTSUD.toString(),
                percRenovavel: percRenovavel == null ? '' : percRenovavel.toString(),

                
            }


        }

        if (tipoEnergia == 'gerada') {


            if (tipoSistema == '') {

                window.toastr.error('<b>Tipo Sistema</b> não pode ficar em branco!')
                return false
    
            }

            if (tipoConexao == '') {

                window.toastr.error('<b>Tipo de Conexão</b> não pode ficar em branco!')
                return false
    
            }

            if (fonte == '') {

                window.toastr.error('<b>Fonte</b> não pode ficar em branco!')
                return false
    
            }

            if (potenciaNominal == '') {

                window.toastr.error('<b>Potência Nominal (kW)</b> não pode ficar em branco!')
                return false
    
            } else {

                
                if (parseInt(potenciaNominal) == 0) {

                    window.toastr.error('<b>Potência Nominal (kW)</b> precisa ser maior que zero!')
                    return false

                }


            }


            if (fatorPotencia == '') {

                window.toastr.error('<b>Fator de Potência (%)</b> não pode ficar em branco!')
                return false
    
            }





            var dataPost = {

                adesao_institucional_id: adesao_institucional_id,
                energia_id: energia_id,
                ano: ano,

                descricaoFatura: descricaoFatura.toUpperCase(),
                
                tipoEnergia: tipoEnergia,
                
                tipoSistema: tipoSistema,
                tipoConexao: tipoConexao,
                fonte: fonte,
                potenciaNominal: potenciaNominal == null ? '' : potenciaNominal.toString(),
                fatorPotencia: fatorPotencia == null ? '' : fatorPotencia.toString(),
                

                pontaJan: pontaJan == null ? '' : pontaJan.toString(),
                foraJan: foraJan == null ? '' : foraJan.toString(),    
                
                pontaFev: pontaFev == null ? '' : pontaFev.toString(),
                foraFev: foraFev == null ? '' : foraFev.toString(),
                
                pontaMar: pontaMar == null ? '' : pontaMar.toString(),
                foraMar: foraMar == null ? '' : foraMar.toString(),
                
                pontaAbr: pontaAbr == null ? '' : pontaAbr.toString(),
                foraAbr: foraAbr == null ? '' : foraAbr.toString(),
                
                pontaMai: pontaMai == null ? '' : pontaMai.toString(),
                foraMai: foraMai == null ? '' : foraMai.toString(),
                
                pontaJun: pontaJun == null ? '' : pontaJun.toString(),
                foraJun: foraJun == null ? '' : foraJun.toString(),
                
                pontaJul: pontaJul == null ? '' : pontaJul.toString(),
                foraJul: foraJul == null ? '' : foraJul.toString(),
                
                pontaAgo: pontaAgo == null ? '' : pontaAgo.toString(),
                foraAgo: foraAgo == null ? '' : foraAgo.toString(),
                
                pontaSet: pontaSet == null ? '' : pontaSet.toString(),
                foraSet: foraSet == null ? '' : foraSet.toString(),
                
                pontaOut: pontaOut == null ? '' : pontaOut.toString(),
                foraOut: foraOut == null ? '' : foraOut.toString(),
                
                pontaNov: pontaNov == null ? '' : pontaNov.toString(),
                foraNov: foraNov == null ? '' : foraNov.toString(),
                
                pontaDez: pontaDez == null ? '' : pontaDez.toString(),
                foraDez: foraDez == null ? '' : foraDez.toString(),
                
                
            }



        }


        
        



        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {



                    if (tipoEnergia == 'comprada') {

                        if (energiaEletricaComprada_id) {

                            //console.log('aqui')

                            api.put(`energiaEletricaComprada/${energiaEletricaComprada_id}`, dataPost).then((result) => {

                                //console.log(result.data)
                                consultaDadosComprada()
                                //setShow(false)
                                window.toastr.success('Registro salvo com sucesso!')
        
                            }).catch((err) => {
        
                                console.log(err.response)
        
                            })

                        } else {

                            api.post(`energiaEletricaComprada`, dataPost).then((result) => {

                                //console.log(result.data)
                                consultaDadosComprada()
                                //setShow(false)
                                window.toastr.success('Registro salvo com sucesso!')
        
                            }).catch((err) => {
        
                                console.log(err.response)
        
                            })

                        }

                        

                    } else {

                        if (tipoEnergia == 'gerada') {

                            if (energiaEletricaGerada_id) {

                                //console.log('put')
                                //return false

                                api.put(`energiaEletricaGerada/${energiaEletricaGerada_id}`, dataPost).then((result) => {

                                    //console.log(result.data)
                                    consultaDadosGerada()
                                    //setShow2(false)
                                    window.toastr.success('Registro salvo com sucesso!')
            
                                }).catch((err) => {
            
                                    console.log(err.response)
            
                                })
    


                            } else {

                                //console.log('post')
                                //return false

                                api.post(`energiaEletricaGerada`, dataPost).then((result) => {

                                    //console.log(result.data)
                                    consultaDadosGerada()
                                    //setShow2(false)
                                    window.toastr.success('Registro salvo com sucesso!')
            
                                }).catch((err) => {
            
                                    console.log(err.response)
            
                                })
    


                            }

                            
                        }

                    }


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    function consultaDadosComprada() {

        //console.log('!!')

        api.get(`energiaEletricaCompradaListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data)

            setResultadoComprada(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} onClick={() => {setEnergiaEletricaComprada_id(rs.energiaEletricaComprada_id);window.$('#modalEnergiaEletricaComprada').modal('show')}}>
                    <td>
                        {rs.descricaoFatura}
                    </td>
                    <td>
                        {rs.concessionaria}
                    </td>
                    <td>
                        {rs.ambienteContratacao}
                    </td>
                    <td>
                        {rs.subgrupo}
                    </td>
                    <td>
                        {rs.modalidadeTarifaria}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    function consultaDadosGerada() {

        //console.log('!!')

        api.get(`energiaEletricaGeradaListaTodos/${energia_id}`).then((result) => {

            //console.log(result.data, '!!!')

            setResultadoGerada(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} onClick={() => {setEnergiaEletricaGerada_id(rs.energiaEletricaGerada_id);window.$('#modalEnergiaEletricaGerada').modal('show')}}>
                    <td>
                        {rs.descricaoFatura}
                    </td>
                    
                    <td>
                        {rs.tipoSistema}
                    </td>
                    <td>
                        {rs.tipoConexao}
                    </td>
                    <td>
                        {rs.fonte}
                    </td>
                </tr>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    
    function apagaEnergiaGerada() {


        if (energiaEletricaGerada_id) {


            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaEletricaGerada/${energiaEletricaGerada_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow2(false)
                            consultaDadosGerada()
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }


    }

    /*
    function apagaEnergiaComprada() {

        if (energiaEletricaComprada_id) {


            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaEletricaComprada/${energiaEletricaComprada_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow(false)
                            consultaDadosComprada()
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }


    }
    


    function carregaConcessionarias() {


        api.get(`energiaEletricaConcessionariaListaTodos`).then((result) => {

            //console.log(result.data)

            setResultadoConcessionarias(result.data.map((rs) =>

                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }

    */
   



    useEffect(() => {

        consultaDadosComprada()
        consultaDadosGerada()
        //carregaConcessionarias()

    }, [ano, energia_id, atualizacaoGestao])


    return (

        <div>

                <div className="col-md-12">
                    <div align="left">

                        <Link to='#' style={{ color: questao }} onClick={() => {setEnunciado('Energia Elétrica');setSecaoEnunciado('Energia Elétrica');window.$('#modalValidacao').modal('show')}}>
                        [Informar Não Conformidade]</Link>
                        <br/><br/>
                        

                        <button type="button" className="btn btn-info" onClick={() => window.$('#modalEnergiaEletricaResumo').modal('show')}  >Resumo</button>
                        &nbsp;
                        <button type="button" className="btn btn-primary" onClick={() => {window.$('#modalEnergiaEletricaComprada').modal('show');setEnergiaEletricaComprada_id()}}  >+ Adicionar Energia Comprada</button>&nbsp;
                        
                        <button type="button" className="btn btn-warning" onClick={() => {window.$('#modalEnergiaEletricaGerada').modal('show');setEnergiaEletricaGerada_id()}}  >+ Adicionar Energia Gerada</button>&nbsp;
                        
                        
                        
                        <br/><br/>

                    </div>
                </div>


                <div className="col-md-12">


                    <Table striped bordered hover>

                        <thead>
                            <tr>
                                <th colspan="5" style={{backgroundColor: '#b2d8ed'}}>
                                    Energia Comprada
                                </th>
                            </tr>
                            <tr>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Fatura

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Concessionária

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Ambiente de Contratação

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Subgrupo

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Modalidade Tarifária

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {resultadoComprada}
                        </tbody>

                    </Table>

                </div>




                <div className="col-md-12">


                    <Table striped bordered hover>

                        <thead>
                            <tr>
                                <th colspan="5" style={{backgroundColor: '#b2d8ed'}}>
                                    Energia Gerada
                                </th>
                            </tr>
                            <tr>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Fatura

                                </th>
                                
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Tipo Sistema

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Tipo de conexão

                                </th>
                                <th style={{backgroundColor: '#e6f7ec'}}>

                                    Fonte

                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {resultadoGerada}
                        </tbody>

                    </Table>

                </div>




                
                <StatusValidacaoSecao desafio="Energia" secaoCampo="secaoEnergiaEletrica" totalPendencias={totalPendencias} nomeDesafio="Desafio Energia" formulario_id={energia_id} secao="Energia Elétrica" adesao_institucional_id={adesao_institucional_id} ano={ano} />
                
                

        </div>

    )

}

export default EnergiaEletrica